export function loadScripts({ urls, WebComponent }) {
    return Promise.all(urls.js.map(url => {
        const script = Array.from(document.scripts).find(({ src }) => src === url);
        if (!script) {
            return new Promise(resolve => {
                const script = document.createElement('script');
                script.crossOrigin = 'anonymous';
                script.onload = () => {
                    script.dataset.webComponent = WebComponent;
                    script.onload = null;
                    resolve();
                };
                script.async = true;
                script.src = url;
                document.body.append(script);
            });
        }
        if (!script.dataset.webComponent) {
            return new Promise(resolve => {
                const originalOnload = script.onload;
                script.onload = (...args) => {
                    originalOnload === null || originalOnload === void 0 ? void 0 : originalOnload.call(script, ...args);
                    script.onload = null;
                    resolve();
                };
            });
        }
        return Promise.resolve();
    }));
}
//# sourceMappingURL=load-scripts.js.map